const formatTime = (seconds: number, preText: string = '', postText: string = '') => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${preText}${mins}:${secs.toString().padStart(2, '0')}${postText}`;
};

export { formatTime };
